"use client";

import React from "react";
import { MapPin, Globe, Map } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const locations = [{
  name: "Atlanta",
  icon: MapPin
}, {
  name: "Fulton County",
  icon: MapPin
}, {
  name: "DeKalb County",
  icon: MapPin
}, {
  name: "Gwinnett County",
  icon: MapPin
}, {
  name: "Cobb County",
  icon: MapPin
}, {
  name: "Paulding County",
  icon: MapPin
}];
export default function ServiceArea() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: nationwideRef,
    isVisible: isNationwideVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="servicearea" className="bg-background py-20 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        {}
        <div ref={headerRef} className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Badge variant="secondary" className="mb-4 text-sm px-3 py-1 bg-secondary/10 text-secondary hover:bg-secondary/20">
            <Map className="size-4 mr-2" />
            Our Reach
          </Badge>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold text-primary mb-6">
            Serving Metro Atlanta and All of Georgia.
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            While RR Recovery Solution is proudly based in Georgia, specializing in the Metro Atlanta area, our commitment to reuniting individuals with their rightful funds extends across the state. We bring local expertise and compassionate service to every case we handle.
          </p>
        </div>

        {}
        <div ref={gridRef} className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 mb-16 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {locations.map((loc, i) => <div data-index={i} key={loc.name} className="h-full">
              <Card className="card h-full flex flex-col items-center justify-center text-center p-6 sm:p-8 border-border/40 bg-background/50 backdrop-blur-sm">
                <div className="bg-primary/10 p-3 rounded-full mb-4 text-primary">
                  <loc.icon className="size-6 sm:size-8" />
                </div>
                <CardTitle className="font-default text-lg sm:text-xl text-foreground">
                  {loc.name}
                </CardTitle>
              </Card>
            </div>)}
        </div>

        {}
        <div ref={nationwideRef} className={`max-w-5xl mx-auto transition-all duration-1000 delay-400 ease-out ${isNationwideVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="card relative overflow-hidden border-primary/20 bg-gradient-to-br from-primary/5 to-transparent">
            {}
            <div className="absolute -right-20 -top-20 size-64 bg-primary/5 rounded-full blur-3xl pointer-events-none" />
            
            <CardContent className="p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 relative z-10">
              <div className="shrink-0 bg-background p-5 rounded-2xl shadow-soft border border-border/50">
                <Globe className="size-12 md:size-16 text-primary" strokeWidth={1.5} />
              </div>
              <div className="text-center md:text-left">
                <h3 className="text-2xl md:text-3xl font-default font-bold text-primary mb-4">
                  Nationwide Recovery Support
                </h3>
                <p className="text-lg text-muted-foreground leading-relaxed">
                  No matter where you are located in the United States, RR Recovery Solution is equipped to assist you. Our team has the resources and expertise to help you navigate the process of claiming what is rightfully yours, ensuring you receive the same level of honest, transparent, and caring service nationwide.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

      </div>
    </section>;
}